import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    users: [],
    foodsIngestedToday: [],
    avatar: [],
    prevRoute: [],
    isTutorial: "",
    axiosHeaders: {},
    oneMonthMealRecord: [],
    hearingsLatestDate: "",
    RefreshTokenUpdate: [],
  },
  mutations: {
    FETCH_ADD_AXIOS_HEADERS(state, axiosHeaders) {
      state.axiosHeaders = axiosHeaders;
    },
    FETCH_ADD_USERS(state, users) {
      state.users = users;
    },
    FETCH_ADD_AVATAR(state, avatar) {
      state.avatar = avatar;
    },
    FETCH_ADD_FOODS_INGESTED_TODAY(state, foodsIngestedToday) {
      state.foodsIngestedToday = foodsIngestedToday;
    },
    FETCH_SET_TUTORIAL(state, isTutorial) {
      state.isTutorial = isTutorial;
    },
    FETCH_ADD_MEAL_RECORD(state, oneMonthMealRecord) {
      state.oneMonthMealRecord = oneMonthMealRecord;
    },
    FETCH_ADD_HEARINGS_DATE(state, hearingsLatestDate) {
      state.hearingsLatestDate = hearingsLatestDate;
    },
    FETCH_ADD_REFRESH_TOKEN(state, RefreshTokenUpdate) {
      state.RefreshTokenUpdate = RefreshTokenUpdate;
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js